// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__WYqvv","placeHolderShimmer":"ReportFilter_placeHolderShimmer__DihaD"};